import { Icon } from "@iconify/react";
import { Colors } from "../../../utils/colors";
import { DMAutomationPlatform } from "@markit/common.types";

type SocialPlatformThumbnailItemProps = {
  mediaUrl: string | undefined;
  size: number;
  platform: DMAutomationPlatform;
};

const PLATFORM_FALLBACK_ICON: Record<DMAutomationPlatform, string> = {
  [DMAutomationPlatform.INSTAGRAM]: "skill-icons:instagram",
  [DMAutomationPlatform.FACEBOOK]: "selfhst:facebook-messenger",
};

// Displays the thumbnail for a trigger's attached post/reel when one exists
export const SocialPlatformThumbnailItem = ({
  mediaUrl,
  size,
  platform,
}: SocialPlatformThumbnailItemProps) => {
  return mediaUrl ? (
    <div>
      <img
        src={mediaUrl}
        alt="Attached post thumbnail"
        style={{
          width: size,
          height: size,
          borderRadius: 4,
          border: `0.5px solid ${Colors.GRAY2}`,
          objectFit: "cover",
          display: "block",
        }}
      />
    </div>
  ) : (
    <Icon
      icon={PLATFORM_FALLBACK_ICON[platform]}
      height={size}
      style={{ flexShrink: 0 }}
    />
  );
};
